import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MapIcon, XIcon } from 'lucide-react';
import { funnelSteps } from '../data/funnel';
export function FunnelMap() {
  const [open, setOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  return <div className="fixed bottom-4 right-4 z-50 print:hidden" data-id="element-11" data-mp="toyfopmac5ej">
      {open && <div className="mb-3 w-72 rounded-xl border border-navy-deep/10 bg-paper p-3 shadow-lift" data-id="element-12" data-mp="tr14x7fm5ui7">
          <p className="px-1 pb-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-navy/50" data-id="element-13" data-mp="60xbfsw53b4x">
            Mapa del funnel
          </p>
          <nav className="flex flex-col" data-id="element-14" data-mp="fybg6v8pabhe">
            {funnelSteps.map((step, i) => {
          const active = pathname === step.path;
          const external = !step.path.startsWith('/');
          const Wrapper = external ? 'a' : Link;
          const linkProps = external ? {
            href: step.path,
            target: '_blank',
            rel: 'noreferrer'
          } : {
            to: step.path
          };
          return <Wrapper key={step.path} {...linkProps as any} onClick={() => setOpen(false)} className={`flex items-center gap-3 rounded-lg px-2 py-2 transition-colors duration-150 ease-out ${active ? 'bg-navy text-paper' : 'text-navy hover:bg-cream'}`} data-id="element-15" data-mp="3pby37a1my8ij" data-mpi={i}>
                  <span className={`grid h-6 w-6 shrink-0 place-items-center rounded-md text-[11px] font-semibold ${active ? 'bg-gold text-navy-deep' : 'bg-cream text-navy/60'}`} data-id="element-16" data-mp="36mzwzdt1yk7e">
                    {i + 1}
                  </span>
                  <span className="min-w-0" data-id="element-17" data-mp="3keeefg7badcc">
                    <span className="block truncate text-sm font-semibold" data-id="element-18" data-mp="2nvqjktg5vbaj">{step.label}</span>
                    <span className={`block truncate text-xs ${active ? 'text-gold-pale' : 'text-navy/50'}`} data-id="element-19" data-mp="2rwk4rf27ybzq">
                      {step.detail}
                    </span>
                  </span>
                </Wrapper>;
        })}
          </nav>
        </div>}
      <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} className="flex items-center gap-2 rounded-full bg-navy-deep px-4 py-2.5 text-sm font-semibold text-paper shadow-lift transition-colors duration-150 ease-out hover:bg-navy" data-id="element-20" data-mp="8r3k8d6zvopo">
        {open ? <XIcon className="h-4 w-4" data-id="element-21" data-mp="37b2c9gaf8aw1" /> : <MapIcon className="h-4 w-4" data-id="element-22" data-mp="37bvec3yfqc7u" />}
        {open ? 'Cerrar' : 'Funnel'}
      </button>
    </div>;
}